// src/components/CountryMembership.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import API from "../../util/api";
import { showErrorModal } from "../../util/general";

const Section = styled.div`
  margin-bottom: 24px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
`;

const SectionHeader = styled.div`
  background: #195174;
  color: white;
  padding: 12px 16px;
  font-size: 1.2rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  td, th { padding: 12px 16px; vertical-align: top; }
  small { color: #555; }
`;

const CheckboxLabel = styled.label`
  display:flex; align-items:center;
  input { margin-right:8px; }
`;

const CountryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Select = styled.select`
  width: 100%; max-width: 300px;
  padding:8px; border:1px solid #195174; border-radius:4px;
`;

export default function CountryMembership({ data, onChange }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    API.getCountries()
      .then(resp => {
        if (resp.status === "Success" && Array.isArray(resp.countries)) {
          setCountries(resp.countries);
        }
      })
      .catch(err => {
        console.error("Failed to load countries:", err);
        setCountries([]);
      });
  }, []);

  return (
    <>
      <Section>
        <SectionHeader>Select Country*</SectionHeader>
        <Table>
          <tbody>
            <tr>
              <td>
                <CheckboxLabel>
                  <input
                    type="checkbox"
                    checked={data.country === "US"}
                    onChange={e => {
                      onChange({ target: { name: "country", value: e.target.checked ? "US" : "" } });
                    }}
                  />
                  United States
                </CheckboxLabel>
              </td>
              <td>
                <CountryRow>
                  <small>or</small>
                  <Select
                    value={data.country === "US" ? "" : data.country}
                    onChange={e => {
                      // clear US checkbox when another is selected
                      onChange({ target: { name: "country", value: e.target.value } });
                    }}
                    disabled={data.country === "US"}
                  >
                    <option value="">Select your country</option>
                    {countries?.map(c => (
                      <option key={c.country} value={c.country}>
                        {c.country_name}
                      </option>
                    ))}
                  </Select>
                </CountryRow>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                <small>
                  * If you are a DoDEA school please select United States.
                </small>
              </td>
            </tr>
          </tbody>
        </Table>
      </Section>

      <Section>
        <SectionHeader>Membership Type</SectionHeader>
        <Table>
          <tbody>
            {[
              ["kt","Kids & Teens","If you are a kid or teen and you want to become a mentor, please visit the iMENTORS section."],
              ["eh","Education Higher","If you are a Higher Education professional or student, you may gain access to Internet safety training and materials to utilize in your courses."],
              ["ed","Educators","If you are a Teacher or other School Official, you can get access to materials used to teach your students about Internet safety."],
              ["hs","Homeschool","If your child/children are Home-schooled, you can get access to our i-LEARN Online training and materials used to teach you and your children about Internet safety."],
              ["op","Parents/50+","If you are a parent or aged fifty or older, you can access online training and materials that will enable you to better understand dangers on the Internet."],
              ["le","Law Enforcement","If you are a Law-Enforcement official, you can have access to materials that will enable you to conduct training sessions.",true],
              ["me","Media","If you are a member of the Media, you will have access to information on Internet safety, including the results from our research studies and a list of company contacts."],
              ["ot","Other","If you do not fall into any of the categories above, you can still find out how you participate or receive information and newsletters."],
            ].map(([val, label, desc, alertFlag]) => (
              <tr key={val}>
                <td style={{ width: "30%" }}>
                  <label>
                    <input
                      type="radio"
                      name="membership"
                      value={val}
                      checked={data.membership === val}
                      onChange={e => {
                        onChange(e);
                        if (alertFlag) {
                          showErrorModal(
                            "It is a crime to falsely impersonate a law enforcement official such as a police officer, a federal officer or employee, or any other public official. Depending on state law, impersonating a law enforcement official may be either a felony or a misdemeanor.  Punishments for impersonating a law enforcement official include imprisonment up to five years (sometimes more), fines (usually $1,000 or more) and a permanent criminal record.  If you falsely register as a law enforcement official on this web site, you may be prosecuted in your state for the crime of impersonating a law enforcement official.",
                            { title: "Important Notice", status: "Warning" }
                          );
                        }
                      }}
                    />{" "}
                    {label}
                  </label>
                </td>
                <td><small>{desc}</small></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Section>
    </>
  );
}
